import {writable} from 'svelte/store';

const {set, update, subscribe} = writable({
    visible: false,
});


const loader = {
    set, update, subscribe, show: () => {
        update(state => {
            state.visible = true;
            return state;
        })
    }, hide: () => {
            update(state => {
            state.visible = false;
            return state;
        })
    }
}
export default loader;